import type { StorageLocal, StorageType } from './types';

// This function is a confirmation of the use of `localStorage` and `sessionStorage`,
const __isWebStorageAvailable = (storageType: StorageType) => {
  let storage: Storage | undefined;
  try {
    if (typeof window === 'undefined') {
      // We are in server side, return false
      return false;
    }
    storage =
      storageType === 'local'
        ? window['localStorage']
        : window['sessionStorage'];
    const testString = '__storage_test__';
    storage.setItem(testString, testString);
    storage.removeItem(testString);
    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      (e.name === 'QuotaExceededError' ||
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      storage != null &&
      storage.length !== 0
    );
  }
};

const __webStorage = (key: string, storageType: StorageType): StorageLocal => {
  const __storage =
    storageType === 'local' ? window['localStorage'] : window['sessionStorage'];

  const write = (value: string) => __storage.setItem(key, value);

  const read = () => {
    const __id = __storage.getItem(key);
    if (__id == null) {
      throw new Error(`${key} not found in ${storageType}Storage`);
    }
    return __id;
  };

  return { write, read };
};

const _mockStorage = (key: string): StorageLocal => {
  let idStore: string | null = null;

  const write = (value: string) => (idStore = value);
  const read = () => {
    if (!idStore) {
      throw new Error(`${key} not found in variable storage`);
    }
    return idStore;
  };
  return { write, read };
};

/**
 * WebStorageを操作するオブジェクトを返す
 * 値が存在しない場合は初期化する
 */
export const storageLocal = (
  key: string,
  initial = '',
  storageType: StorageType = 'session',
): StorageLocal => {
  const storage = __isWebStorageAvailable(storageType)
    ? __webStorage(key, storageType)
    : _mockStorage(key);

  try {
    storage.read();
  } catch {
    storage.write(initial);
  }
  return storage;
};
